import React, { useEffect, useState } from 'react';
import { toUnicode , btoa, atob } from '../../../cryptographic/crypto'
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
// import KeyboardIcon from '@mui/icons-material/Keyboard';
import Recording from "../../../assets/images/recorder.gif";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import KeyboardIcon from "../../../assets/images/keyboard.png"
import { languages } from '../../utility/constants';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import {stopSpeaking} from "../../utility/constants";
import VolumeMuteIcon from '@mui/icons-material/VolumeMute';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import Idea from "../../../assets/images/ttd/idea.png";
import Ideas from "../../../assets/images/ttd/ideas.png";
import { getCookie } from '../../utility/cookies';
import {parseIfJson} from "../../utility/constants"

function TypoBar({openFeedback, noFeedback,socket, prefLang, setPrefLang, startChat, setStartChat, events, 
    startChatWithHi, botInfo, voiceChat, openMic, setOpenMic,setUsetLastMsg ,voiceEnabled,hideFooter,blockMic,
    setBlockMic,setScroll,scroll,disableResp,showPopularSearch, setShowPopularSearch, hasPopularSearch,showTypeMessage}) {
    const [ messageText , setMessageText ] = useState('')
    const [openPreChatBody, setOpenPreChatBody] = useState(true);
    const [viewSend, setViewSend] = useState(false)
    const [disableMic, SetDisabledMic] = useState(false)
    const [muted, setMuted] = useState(false)
    const windowGroupId = process.env.REACT_APP_PROD === "true" ? window.chat_widget_reference_no : process.env.REACT_APP_GROUPID
    function escapeHTML(input) {
        return input
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }
    const setMessage = (e) =>{
        setMessageText(e.target.value)
        var status = "E";
        if(e.target.value)
            status = "A";
        else
            status = "E";
        socket.emit(btoa(["user-typeing",{status:status,group: windowGroupId}]));
        // socket.emit(btoa(["user-typeing",{status:status,group: "6rtkcd34cgv66cb6cgt3grhgcdj68thj6cvp2e8"}]));
    }

   
    const sendMessage2 = (e) => {
        if(disableResp && (process.env.REACT_APP_TYPE === "Full" || window.bot_type === "Full")){
            console.log("input disabled");
        }else{
            if (e.keyCode === 13 && e.shiftKey) {
        
            } else if (e.keyCode === 13) {
                e.preventDefault();
                sendMessage()
                setViewSend(false)
            }
        }
    }

    const sendMessage = () => {
        if(disableResp && (process.env.REACT_APP_TYPE === "Full" || window.bot_type === "Full")){
            console.log("input disabled");
        }else{
            if(messageText == ''){

            }
            else{
                setMessageText('')
                let sendData = {
                    text : escapeHTML(messageText)
                }
                if(getCookie("firstMsg") === "null"){
                    sendData.info = parseIfJson(atob(getCookie("uInfo")))?.info;
                    if(window?.access_token){
                        sendData.info.access_token = window.access_token;
                    }
                    if(window?.user_id){
                        sendData.info.user_id = window.user_id;
                    }
                }
                socket.emit(btoa(["user-send",sendData]));
                setUsetLastMsg(messageText)
                setMuted(false)
            }
        }
    }
    useEffect(()=>{
        if (events) {
            if (Object.keys(events).length > 0) {
                if(events["request-form"]){
                    if(events["request-form"][1][prefLang] === undefined){
                        setOpenPreChatBody(true)
                    }
                    else if(events["request-form"][1][prefLang].length = 0 ){
                        setOpenPreChatBody(false)
                    }
                    else{
                        setOpenPreChatBody(true)
                    }
                    
                }
            }
        }
    });

    // voice code start
    const {
        transcript,
        listening,
        resetTranscript,
        interimTranscript, 
        finalTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition({});

    useEffect(() => {
        if (finalTranscript !== '') {
            let sendData = {
                text : finalTranscript
            }
            socket.emit(btoa(["user-send",sendData]));
            setUsetLastMsg(finalTranscript)
            setMuted(false)
        }
    }, [interimTranscript, finalTranscript]);
    // voice code end

    useEffect(()=>{
        if (!browserSupportsSpeechRecognition) {
            SetDisabledMic(true)
        }else{
            SetDisabledMic(false)
            stopSpeaking()
        }
    },[])

    const preventCopy=(e)=>{
        if(botInfo?.data?.mobileAppConfig?.pasteEnable === "Y"){
            e.preventDefault() 
            return false
        }
    }
    
    var voiceLang = languages?.find(lang=>lang.value === prefLang)
    const checkFullBot = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Full" || botType === "TlkDocs") {
            return true
        } else {
            return false
        }
    }

    const handleChatMessage=()=>{
        if(checkFullBot()){
            if(showTypeMessage){
                return "type 'hi' to get started"
            }else{
                return "Type a message"
            }
        }else{
            return botInfo?.data?.bot?.nickName ? "Talkk with "+botInfo?.data?.bot?.nickName : 'Message...'
        }
    }
    
    return(
        <>
       {
        startChat === true &&
        (
            <div className={`chat-send-msg-wrapper has-voice-chat ${showPopularSearch ? "has-popular-serch-item" : ""} ${hasPopularSearch ? "has-popular-serach" : ""} ${openFeedback === true ? 'hide-div' : ''} ${noFeedback === true ? 'hide-div' : ''} `}>
            <div className="quick-links-wrapper"></div>
            <div className={`footer-wrapper ${hideFooter ? "hidden-footer-wrapper" : ""} ${openMic ? "voice-footer" : ""}`}>
                {
                    openMic && listening && voiceLang?.lang_enable === "Y" && 
                    <div className="voice-text-wrapper">{transcript}</div>
                }
                {
                    openMic && voiceLang?.lang_enable === "Y" ?
                        
                        <>
                            {
                                listening ?
                                    <img src={Recording} alt="voice-recording" className='voice-wave'/>
                                :
                                    <div className={`voice-record-wrapper`}>
                                        {/* {
                                            blockMic ?
                                                <CloseIcon className="mic-icon" onClick={()=> {stopSpeaking();setBlockMic(false)}}  />
                                            :   
                                                <KeyboardVoiceIcon className="mic-icon" onClick={SpeechRecognition.startListening}/>
                                        } */}
                                        {
                                            muted ?
                                                <VolumeMuteIcon className="mute-icon muted" onClick={()=> {window?.speechSynthesis?.resume();setMuted(false)}} />
                                            :
                                                <VolumeOffIcon className="mute-icon" onClick={()=> {window?.speechSynthesis?.pause();setMuted(true)}} />
                                        }
                                        <KeyboardVoiceIcon className="mic-icon" onClick={()=> {stopSpeaking(); SpeechRecognition.startListening({ language: prefLang === "fr" ? 'fr-FR' : "en-US" })}}/>
                                        <img src={KeyboardIcon} alt="keyboard icon"  onClick={()=> {setOpenMic(false); stopSpeaking(); setBlockMic(false); setScroll(!scroll)}} className="keyboard-icon"/>
                                    </div>
                            }
                        </>
                    :
                        <div className="input-fields typebar-fields only-typebar-field">
                            {
                                voiceEnabled && !disableMic ?
                                    voiceLang?.lang_enable === "Y" ?
                                        <>
                                            <textarea id="btn-input" type="text" onPaste={(e)=> preventCopy(e)} className="form-control message-input talkkMessageBox" 
                                            placeholder={handleChatMessage()} row="1" value={messageText} onChange={(e)=>{setMessage(e);if(e.target.value?.length > 0){setViewSend(true)}else{setViewSend(false)}}} onKeyDown={(e)=>sendMessage2(e)}></textarea>
                                            {
                                                hasPopularSearch ?
                                                    showPopularSearch ?
                                                        <i className={`ttd ttd-idea popular-serach-img active-serch`} onClick={() => setShowPopularSearch(!showPopularSearch)} ></i>
                                                    :
                                                        <i class="ttd ttd-idea1  popular-serach-img" onClick={() => setShowPopularSearch(!showPopularSearch)}></i>
                                                :
                                                    <></>
                                            }
                                            {
                                                viewSend ?
                                                    <i className="ttd ttd-up-arrow mic-icon-wrapper send-icon-wrap" onClick={()=> {sendMessage(); setViewSend(false)}}></i>
                                                :
                                                    <KeyboardVoiceIcon className="mic-icon-wrapper send-icon-wrap" onClick={()=> {setOpenMic(true);SpeechRecognition.startListening({ language: prefLang === "fr" ? 'fr-FR' : "en-US" });setScroll(!scroll)}}/>
                                            }
                                        </>
                                    :
                                        <>
                                            <textarea id="btn-input" type="text" onPaste={(e)=> preventCopy(e)} className="form-control message-input talkkMessageBox" 
                                            placeholder={handleChatMessage()} row="1" value={messageText} onChange={(e)=>setMessage(e)} onKeyDown={(e)=>sendMessage2(e)}></textarea>
                                            <i className="ttd ttd-up-arrow mic-icon-wrapper send-icon-wrap" onClick={sendMessage}></i>
                                        </>
                                :
                                    <>
                                        <textarea id="btn-input" type="text" onPaste={(e)=> preventCopy(e)} className="form-control message-input talkkMessageBox" 
                                        placeholder={handleChatMessage()} row="1" value={messageText} onChange={(e)=>setMessage(e)} onKeyDown={(e)=>sendMessage2(e)}></textarea>
                                        <i className="ttd ttd-up-arrow mic-icon-wrapper send-icon-wrap" onClick={sendMessage}></i>
                                    </>
                            }
                        </div>
                }
            </div>
        </div>
        )
       }
       </> 
        
    )
}
export default TypoBar;